import axios from "@/utils/axios";

const API_URL = process.env.VUE_APP_API_URL || "";

export const getEmployeesData = async () => {
  const response = await axios.get(`${API_URL}/users`);
  return response.data.data;
};

export const createEmployee = async (data) => {
  const response = await axios.post(`${API_URL}/users`, data);
  return response.data.data;
};

export const checkEmployeeEmail = async (email, ignoreId = null) => {
  const response = await axios.get(`${API_URL}/users/email/check`, {
    params: {
      email,
      ignore_id: ignoreId ?? undefined,
    },
  });
  return response.data;
};

export const deleteEmployee = async (id) => {
  const response = await axios.delete(`${API_URL}/users/${id}`);
  return response.data;
};

export const updateEmployee = async (id, data) => {
  const response = await axios.put(`${API_URL}/users/${id}`, data);
  return response.data.data;
};
